import {useAppSelector} from '../../services/hooks';
import {useTranslation} from 'react-i18next';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './footer.scss';

export default function Footer() {
    const {t} = useTranslation();
    const footerData = useAppSelector((state) => state.footer);

    // TODO: Handlowcy są w kolejności losowej
    //const contacts = footerData.sellers.sort( () => .5 - Math.random() );

    const showContacts = (obj: Object) => Object.entries(obj).map(([key, value]: any, index) => (
        <li key={index}><strong>{key}</strong>&nbsp;<a href={'tel:' + value}>{value}</a></li>
    ));

    const showLinks = (obj: Object) => Object.entries(obj).map(([key, value]: any, index) => (
        <li key={index} className='py-1'><a href={key}>{value}</a></li>
    ));

    return (
        <Container fluid className='footerContainerDynamic'>
            <Container className='py-5 text-white-50'>
                <Row>
                    <Col xs={12} lg={3}>
                        <img src="/tpl/images/romerobjectwhite.svg" alt="ROMER"/><br/><br/>
                        <p className='newLine'>
                            {footerData.address}
                        </p>
                    </Col>
                    <Col xs={12} lg={3}>
                        <h5>{t('footer.sales_department')}</h5>
                        <p>
                            <a href={`mailto:${footerData.contactEmail}`}>{footerData.contactEmail}</a><br/>
                            (07:00 - 15:00 CET)
                        </p>
                        <ul>
                            {showContacts(footerData.sellers)}
                        </ul>
                    </Col>
                    <Col xs={12} lg={3}>
                        <h5>{t('footer.service_department')}</h5>
                        <ul className={"pb-2"}>
                            <li><a href={`mailto:${footerData.serviceEmail}`}>{footerData.serviceEmail}</a></li>
                        </ul>

                        <h5>{t('footer.service_dispatcher')}</h5>
                        <ul className={"pb-2"}>
                            {showContacts(footerData.service)}
                        </ul>

                        <h5>{t('footer.financial_department')}</h5>
                        <ul className={"pb-2"}>
                            <li><a href={`mailto:${footerData.financialEmail}`}>{footerData.financialEmail}</a></li>
                        </ul>
                    </Col>
                    <Col xs={12} lg={3}>
                        <h5 className={'text-uppercase'}>{t('footer.important_links')}</h5>
                        <ul className="pt-2">
                            {showLinks(footerData.importantLinks)}
                        </ul>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}